<template>
    <div class="modal" :class="modalWidth">
        <div class="modal--body">
            <slot />
        </div>
        <div class="modal--background"></div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        width: null,
    },
    computed: {
        modalWidth() {
            return this.width ? 'modal--' + this.width : '';
        }
    }
};
</script>
